// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
// import vConsole from './vconsole'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false

// Vue.use(ElementUI);

new Vue({
  render: h => h(App),
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js